<script setup lang="ts">
interface Props {
  pageDataCacheKey: string
  relatedPosts: number[]
}

const props = defineProps<Props>()
const asyncDataCacheKey = computed(() => `${props.pageDataCacheKey}-related-post`)

const { data, status, error } = await useAsyncData(asyncDataCacheKey.value, async () => {
  return Promise.all(
    props.relatedPosts.slice(0, 3).map(id => $fetch(`/internals/post/${id}/related`)),
  )
}, {
  lazy: true,
})

const { isLoading } = useIsLoading(status)
</script>

<template>
  <section
    v-if="!error"
    class="bg-peacock-25 w-full space-y-8 py-14"
  >
    <p class="text-center text-3xl font-semibold">
      {{ $t('see_more_related_posts') }}
    </p>
    <div
      v-if="isLoading"
      class="text-center"
    >
      <YscLoader class="h-8 w-8" />
    </div>
    <div
      v-else-if="data"
      class="relative mx-auto grid max-w-screen-xl gap-6 px-4 lg:grid-cols-3"
    >
      <AppPostCard
        v-for="post in data"
        :key="post.id"
        :image-url="post.featured_image.url"
        :image-alt="post.featured_image.alt"
        :to="post.html_path"
        no-seo-title
      >
        <template
          v-if="post.tags.length"
          #tag
        >
          {{ post.tags[0].name }}
        </template>

        <template #title>
          {{ post.title }}
        </template>

        <template #subtitle>
          <p v-if="post.sub_title">
            {{ post.sub_title }}
          </p>
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-else
            v-html="post.description"
          />
        </template>
      </AppPostCard>
    </div>
  </section>
</template>
